import axios from 'axios';
import constants from 'constants';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import storage from 'services/storage';
import { toast } from 'react-toastify';
import actions from 'actions';
import validator from 'services/validator.js';
import validate from 'validate.js';
import { push } from 'redux-router';

const {
  cleanErrors,
  addRequestError,
  addValidateError,
  addErrorsSaga,
  updateUser,
  setProfileConfirmation
} = actions;

const {
  CREATE_USER_SAGA,
  CREATE_USER_FAILED,
  API_CREATE_USER,
  API_SHOW_USER,
  ERROR_TYPE_USER_CREATE_ERROR,
  ERROR_TYPE_USER_UPDATE_ERROR,
  LOAD_CURRENT_USER_SAGA,
  API_UPDATE_USER,
  UPDATE_USER_SAGA,
  ZOOM_INFO_STATUS,
  UPDATE_URL_USER_SAGA
} = constants;

const apiCreateUser = (user) => {
  return axios.post(API_CREATE_USER, {
    user: user
  })
}

const apiUpdateUser = (user) => {
  return axios.put(`${API_UPDATE_USER}${user.id}`, {
    user: user
  })
}

const loadUser = (id) => (
  axios.get(`${API_SHOW_USER}${id}`)
)

const getCurrentUser = (state) => (state.users.user);
const getCurrentSession = (state) => (state.session);

const notififyAccountCreate = () => {
  toast.success('You\'re account was successfully created.')
}

const notififyProfileUpdate = () => {
  toast.success('You\'re profile was successfully updated.')
}

const notififyValidateError = (errors) => {
  toast.success(errors)
}

const writeAuthSessionToStorage = (user, session) => {
  storage.setSessionData(user, session)
}

function* createUser({ user }) {
    const userData = user;
    try {
      const errors = validator.validate(userData, 'user');
      if (errors) {
        yield put(addValidateError(ERROR_TYPE_USER_CREATE_ERROR, errors));
        return;
      } else {
        yield put(cleanErrors(ERROR_TYPE_USER_CREATE_ERROR))
      }

      const response = yield call(apiCreateUser, userData);

      const user = response.data.user;
      const session = {
        token: response.data.token
      };

      yield put(updateUser(user, session));

      yield call(writeAuthSessionToStorage, user, session);

      yield call(notififyAccountCreate);

    } catch (e) {
      yield put(addErrorsSaga(ERROR_TYPE_USER_CREATE_ERROR, e.response))
    }
}

function* loadCurrentUser() {
  try {
    const currentUser = yield select(getCurrentUser);
    if (!currentUser.id) {
      return;
    }
    const response = yield call(loadUser, currentUser.id);
    const user = response.data.user;
    const session = {
      token: response.data.token
    };
    yield put(updateUser(user, session))
    yield call(writeAuthSessionToStorage, user, session);
  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response));
  }
}

function* updateUrlUser(data) {
  try {
    const userUrl = {
      id: data.data.id,
      is_valid: true,
      email_confirmed: true
    }
    const sessionUrl = {
      token: data.data.token
    };
    yield put(updateUser(userUrl, sessionUrl));
    const response = yield call(loadUser, userUrl.id);
    const user = response.data.user;
    const session = {
      token: response.data.token
    };
    yield put(updateUser(user, session));
    yield call(writeAuthSessionToStorage, user, session);
  } catch (e) {
    console.log(e);
  }
}

function* updateUserSaga({ user }) {
    const userData = user;
    try {
      const currentUser = yield select(store => store.users.user);
      const errors = validator.validate(userData, 'userProfile');
      if (errors) {
        yield put(addValidateError(ERROR_TYPE_USER_UPDATE_ERROR, errors));
        return;
      } else {
        yield put(cleanErrors(ERROR_TYPE_USER_UPDATE_ERROR))
      }

      const response = yield call(apiUpdateUser, userData);

      const user = response.data.user;
      const session = {
        token: response.data.token
      };

      yield put(updateUser(user, session));

      yield call(writeAuthSessionToStorage, user, session);

      yield call(notififyProfileUpdate);

      if (currentUser.is_valid != user.is_valid) {
        yield put(setProfileConfirmation(ZOOM_INFO_STATUS.open))
      }
      yield put(push('/'))
      yield call(() => window.scrollTo(0, 0))

    } catch (e) {
      console.log(e);
      yield put(addErrorsSaga(ERROR_TYPE_USER_UPDATE_ERROR, e.response))
    }
}

// SAGAS
function* createUserSaga() {
  yield takeLatest(CREATE_USER_SAGA, createUser)
}

function* loadCurrentUserSaga() {
  yield takeLatest(LOAD_CURRENT_USER_SAGA, loadCurrentUser)
}

function* __updateUserSaga() {
  yield takeLatest(UPDATE_USER_SAGA, updateUserSaga)
}

function* updateUrlUserSaga() {
  yield takeLatest(UPDATE_URL_USER_SAGA, updateUrlUser)
}

export {
  createUserSaga,
  loadCurrentUserSaga,
  updateUrlUserSaga,
  __updateUserSaga
};



/** WEBPACK FOOTER **
 ** ./src/sagas/users.js
 **/